<template>
  <div>
    <v-app id="inspire" dark class="estilo_jep">

      <v-toolbar app fixed clipped-left>
        <v-img max-width="250px" src="/images/logo.png"></v-img>
        <v-toolbar-title>Traslado y presentación de observaciones a las Versiones Voluntarias de las víctimas acreditadas en el Caso No. 01</v-toolbar-title>
        <!-- <v-spacer></v-spacer> -->

        <!-- <v-menu offset-y origin="center center" :nudge-bottom="10" transition="scale-transition">
          <v-btn icon large flat slot="activator" @click="logout()" alt="Cerrar sesión">
            <v-icon>exit_to_app</v-icon>
          </v-btn>
        </v-menu> -->
      </v-toolbar>

      <v-content>
        <v-container>
          <v-layout justify-center>
            <v-flex>
              <router-view></router-view>
            </v-flex>
          </v-layout>
        </v-container>
      </v-content>
      <v-footer app fixed>
        <v-flex py-2 text-xs-center white--text xs12>Sistema de Gestión de Abogados - Módulo de Traslados - JEP &copy; {{ new Date().getFullYear() }}</v-flex>
      </v-footer>
    </v-app>
  </div>
</template>

<script>
import { EventBus } from "./EventBus";
export default {
  props: [
    "app_name",
    "url_action",
    "url_pwd_recover",
    "has_route_pwd_recover"
  ],
  data() {
    return {
      image_src: require("../logo.png")
    };
  },
  created() {
    // this.emitDatosAutenticacion();
  },
  mounted() {
    this.emitirDatosAutenticacion();
  },
  computed: {},
  methods: {
    emitirDatosAutenticacion() {
      EventBus.$emit("DATA_FORM_AUTH_URL_ACTION", this.url_action);
      EventBus.$emit("DATA_FORM_AUTH_URL_PWD_RECOVER", this.url_pwd_recover);
      EventBus.$emit(
        "DATA_FORM_AUTH_HAS_ROUTE_PWD_RECOVER",
        this.has_route_pwd_recover
      );
    },
    logout() {
      console.log(window.user);
      axios
        .post("/logout")
        .then(response => {
          window.location.replace("/traslado");
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>

<style lang="css" scoped>
.estilo_jep {
  background-color: #0b121f;
}
</style>
